const env = process.env.REACT_APP_ENV;

let url = ""
if (env === "HML") {
    url = "https://hml-api-bac.braspress.com.br/api";
} else if (env === "PRD") {
    url = "https://braspressaircargo.com/api";
} else {
    url = "https://dev-api-bac.braspress.com.br/api";

}

module.exports = url;   
